
import { lighten } from 'polished';
import styled from 'styled-components';
import bgImage from '../../assets/images/golf-field3.jpg';

export const Container = styled.div`
  width: 100%;
  height: auto;
  background-image: url(${bgImage});
  background-position: bottom;
	background-size: cover;
	background-repeat: no-repeat;
  padding: 50px 0px 50px 0px;

  .countdown {
    text-transform: uppercase;
    font-weight: bold;
    color: #006747;
    background-color: yellow;
  }

  .countdown span {
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
      font-size: 3rem;
      margin-left: 0.8rem;
  }

  .countdown span:first-of-type {
      margin-left: 0;
  }

  .countdown-circles {
      text-transform: uppercase;
      font-weight: bold;
  }

  .countdown-circles span {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  }

  .countdown-circles span:first-of-type {
      margin-left: 0;
  }
`;

export const CountdonwTitle = styled.div`
  color: #006747;
  font-family: 'Oswald', sans-serif;
  letter-spacing: 1px;
`;

export const JoinButton = styled.div`
  @media (max-width: 1024px) {
    font-size: 20px;
    width: 90vw;
  }

  color: yellow;
  padding: 10px 0;
  width: 250px;
  font-family: 'Oswald', sans-serif;
  letter-spacing: 2px;
  font-size: 18px;
  background-color: #006747;
  text-align: center;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 1px 1px 3px yellow;
  border: 1px solid yellow;
  transition: all 0.5s;

  svg {
    margin-right: 15px;
    padding-bottom: 3px;
    color: ${lighten(0.1, 'yellow')};;
  }

  &:hover {
    background-color: ${lighten(0.1, '#006747')};
  }

  &:active {
    background-color: ${lighten(0.9, '#006747')};
  }
`;

type RulesPanelProps = {
  isOpen: boolean
}

export const RulesContainer = styled.div<RulesPanelProps>`
  @media (max-width: 1024px) {
    width: 85vw;
    right: ${props => props.isOpen ? '0' : '-87vw'};
  }
  
  position: fixed;
  overflow-y: auto;
  width: 450px;
  height: 100vh;
  background: white;
  box-shadow: 0 5px 5px 5px gray;
  top: 0;
  right: ${props => props.isOpen ? '0' : '-455px'};
  z-index: 9999;
  transition: 0.3s;
`;

export const RulesContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RulesHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid #006747;
  padding: 10px 0;
  background-color: #fff;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 22px;
  padding-left: 15px;
`;

export const CloseIcon = styled.div`
  padding-right: 15px;
  :hover {
    color: #006747;
    cursor: pointer;
  }
`;

export const RulesDescription = styled.div`
  ol {
    counter-reset: li; /* Initiate a counter */
    list-style: none; /* Remove default numbering */
    *list-style: decimal; /* Keep using default numbering for IE6/7 */
    font: 16px 'trebuchet MS', 'lucida sans';
    padding: 0;
    margin-bottom: 2em;
    text-shadow: 0 1px 0 rgba(255,255,255,.5);
    text-align: justify;
  }

  ol ol {
    margin: 0 0 0 2em; /* Add some left margin for inner lists */
  }
  .circle-list li{
    padding: 2.5em;
    border-bottom: 1px dashed #ccc;
  }

  .circle-list h2{
    position: relative;
    margin: 0;
  }

  .circle-list p{
    margin: 0;
  }

  .circle-list h2:before{
    content: counter(li);
    counter-increment: li;
    position: absolute;
    z-index: -1;
    left: -1.2em;
    top: -.8em;
    /* background: #f5f5f5; */
    height: 1.8em;
    width: 1.8em;
    border: .1em solid rgba(0,0,0,.05);
    text-align: center;
    font: italic bold 1em/1.2em Georgia, Serif;
    color: #ccc;
    border-radius: 1.5em;
    transition: all .2s ease-out;

    background-color: rgba(0, 103, 71, 0.2);
    border-color: rgba(0,0,0,.08);
    border-width: .2em;
    color: yellow;
  }

  .circle-list li:hover h2:before{
    background-color: #ffd797;
    border-color: rgba(0,0,0,.08);
    border-width: .2em;
    color: #444;
    transform: scale(1.1);
  }

`;
